// extracted by mini-css-extract-plugin
export default {"link":"Privacy_link__kzDtG","modalOverlay":"Privacy_modalOverlay__U-6sc","modalContent":"Privacy_modalContent__DoXhr","closeButton":"Privacy_closeButton__WEPXT"};